import React, { useState } from "react";

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "What is your HOA platform?",
      answer:
        "Our platform is a modern, virtual solution that empowers HOA board members to self-manage day-to-day operations, reduce dependency on third-party management companies, and take control of their community's future — all with the support of AI and intuitive tools.",
    },
    {
      question: "Who is this platform for?",
      answer:
        "Our platform is built for self-managed HOAs, boards looking to transition away from costly property managers, and communities that want greater transparency, control, and cost savings. It also works seamlessly with any management company, making it ideal for hybrid management models.",
    },
    {
      question: "What can our HOA do on the platform?",
      answer:
        "You can manage all core HOA activities, including financial tracking and reporting, dues collection and online payments, maintenance requests and work orders, document storage and community communication, meeting agendas, voting, and board collaboration, plus AI-powered suggestions and workflow automation.",
    },
    {
      question: "Do we need a management company to use your platform?",
      answer:
        "Our platform is designed to be fully self-managed. However, if you choose to work with a management company, you can grant them access without locking into their proprietary tools. Additionally, you will still need to know and be aware of the rules and regulations of your state, so you may want to consult with an attorney on the best approach. We will in the near future be able to provide management oversight as well in future releases.",
    },
    {
      question: "What kind of support do you offer?",
      answer:
        "We provide live onboarding support, ongoing email and chat support, access to a robust knowledge base and training guides, and dedicated account management for larger HOAs.",
    },
    {
      question: "Is our data secure?",
      answer:
        "Yes. We use bank-grade encryption and follow industry best practices for data security, privacy, and backup. Your data is owned by your HOA and remains fully portable on AWS cloud servers with 256-bit encryption.",
    },
    {
      question: "We're currently using a management company's platform. Can we switch to yours?",
      answer:
        "Absolutely. Our team can help guide your transition and import your documents, contact lists, and payment records. You retain full control — and can still invite your management company to collaborate within our system, if desired.",
    },
    {
      question: "What if our HOA isn't very tech-savvy?",
      answer:
        "Our platform is designed to be simple and intuitive, with step-by-step guidance and responsive support. You don't need to be a tech expert to run your HOA like a pro.",
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section
      id="faq"
      className="bg-white py-4 px-4 sm:px-6 lg:px-8 flex justify-center items-center"
    >
      <div className="max-w-7xl w-full">
        <h2 className="text-center text-2xl md:text-4xl font-bold mb-6 bg-gradient-to-r from-[#2731a3] to-[#1a2280] bg-clip-text text-transparent">
          Frequently Asked Questions
        </h2>
        {faqs.map((faq, index) => (
          <div
            className="border-b border-gray-200 mb-3 rounded-lg shadow-sm hover:shadow-md transition-shadow duration-300"
            key={index}
          >
            <button
              className="w-full bg-transparent border-none text-left py-3 px-5 text-base sm:text-lg font-semibold cursor-pointer flex justify-between items-center text-[#2731a3] hover:text-[#1a2280] transition-colors duration-300 focus:outline-none"
              onClick={() => toggleFAQ(index)}
            >
              <span>{faq.question}</span>
              <span
                className={`text-xl sm:text-2xl transition-transform duration-300 text-blue-600 ${activeIndex === index ? "rotate-180" : ""
                  }`}
              >
                {activeIndex === index ? "−" : "+"}
              </span>
            </button>
            <div
              className={`overflow-hidden transition-all duration-500 ease-in-out ${activeIndex === index ? "max-h-96 opacity-100" : "max-h-0 opacity-0"
                }`}
            >
              <div className="px-5 pb-3 pt-1 text-gray-600 text-sm sm:text-base">
                <p>{faq.answer}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;